// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"867":"3b551c213f363658","3578":"425efebfc692f61f","3874":"521b75bf472907c1","8052":"3b350caed55b200f"}[chunkId] + ".css";
};